<!--
 * @Author: your name
 * @Date: 2021-08-16 14:23:41
 * @LastEditTime: 2022-09-14 11:01:06
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/add/index.vue
-->
<template>
  <div class="details">
    <div class="itemposter">
      <mt-swipe :auto="3000">
        <mt-swipe-item v-for="(item, idx) of details" :key="idx">
          <img :src="item.thumbUrl" style="width:100%;height:100%" />
        </mt-swipe-item>
      </mt-swipe>
    </div>
    <div class="rules">
      <p class="rules_tit">————活动规则————</p>
      <p class="rule_content">{{ content }}</p>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from "mint-ui";
export default {
  name: "posterdetail",
  components: {
    Swipe,
    SwipeItem
  },
  data() {
    return {
      details: [],
      content: ""
    };
  },
  mounted() {
    const query = this.$route.query;
    console.log(query);
    this.details = JSON.parse(query.data).details;
    this.content = JSON.parse(query.data).content;
  },
  methods: {}
};
</script>
<style scoped>
.details {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 20px;
  background: #ffffff;
  /* background: burlywood; */
}
.itemposter {
  width: 100%;
  height: 330px;
  border-radius: 6px;
  /* margin: 15px 0 0 8px; */
}
.rules {
  width: calc(100% - 20px);
  margin: 10px;
  padding: 19px 28px 16px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.39);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 6px;
  text-align: center;
}
.rules_tit {
  font-size: 10px;
  font-weight: 400;
  line-height: 8px;
  color: #212121;
}
.rule_content {
  width: 100%;
  margin-top: 17px;
  line-height: 14px;
  color: #757575;
  font-size: 8px;
  text-align: left;
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/posterdetail/index.vue